import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { StatusTag } from 'components';
import { Toolbar, Table } from './components';
import { IUsersTable } from 'types/usersTable';
import { getUsersData } from 'services/usersTable';
import { RouteComponentProps } from 'react-router';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { userStatusLabels } from 'constants/users';
import useEventBus from 'hooks/useEventBus';
interface IProps extends RouteComponentProps {}
export const Users: React.FC<IProps> = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);

  const eventBus = useEventBus();
  useEffect(() => {
    eventBus.dispatchEvent('onChangeTitle', 'Usuários');
  }, []);
  const [data, setData] = useState<IUsersTable>({ content: [] });

  const handleGetData = async (query?: string) => {
    setIsLoading(true);
    try {
      const defaultQuery = 'size=10&sort=name,asc';
      let newQuery = `?${defaultQuery}`;

      if (query) {
        if (query[0] === '?') {
          newQuery = `${query}&${defaultQuery}`;
        } else {
          newQuery = `?${query}&${defaultQuery}`;
        }
      }

      const response = await getUsersData(newQuery);
      setData(response.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaginate = (newPage: number) => {
    const newFilterData = queryToObj(history.location.search);
    function valuePositive(value: number) {
      const query = localStorage.getItem('queryPageUser') || '';
      if (value === -1) {
        return 0;
      } else if (value === Number(query)) {
        return Math.abs(Number(query));
      } else {
        return Math.abs(value - 1);
      }
    }

    setTimeout(() => {
      localStorage.removeItem('queryPageUser');
    }, 1000);

    const query = objToQuery({
      ...newFilterData,
      page: valuePositive(newPage),
    });
    if (
      newFilterData.page &&
      typeof newFilterData.page === 'string' &&
      newPage - 1 === parseInt(newFilterData.page)
    ) {
      return '';
    }

    history.replace({
      pathname: routePaths.users,
      search: `?${query}`,
    });
  };

  useEffect(() => {
    handleGetData(history.location?.search);
    const removeListen = history.listen(listener => handleGetData(listener.search));

    return () => {
      removeListen();
    };
  }, []);

  const formatExpirationDate = (data: string) => {
    return data !== null
      ? new Date(data).toLocaleDateString('pt-Br', {
          timeZone: 'UTC',
        })
      : '-';
  };

  return (
    <Box w="100%">
      <Toolbar history={history} />
      <Box padding="0.1rem 0rem 1rem" background="#fff" borderRadius="10px">
        <Table
          enabled={data.content.map(user => user.enabled)}
          id={data.content.map(item => item.id)}
          loading={isLoading}
          row={[0]}
          headers={[
            'Nome',
            'Perfil de acesso',
            'Cargo',
            'Departamento',
            'Tipo',
            'Expiração',
            'Status',
            '',
          ]}
          sizes={[1, 0.5, 0.5, 0.5, 0.5, 0.5, 0.3]}
          fullLoading={false}
          data={data}
          locations={data?.content.map(user => '/users/edit/' + user.id)}
          rows={data?.content.map(user => [
            user.name,
            user.employeeDanielLaw,
            user.jobTitle,
            user.department,
            user.temporaryAccess,
            formatExpirationDate(user.expirationDate),
            <StatusTag key={user.id} variant={user.enabled ? 'accept' : 'danger'}>
              {user.enabled ? userStatusLabels.active : userStatusLabels.inactive}
            </StatusTag>,
          ])}
          pagination={{
            initialPage: Number(localStorage.getItem('queryPageUser')) + 1 ?? 1,
            onChange: handlePaginate,
            pagesCount: data?.totalPages || 1,
          }}
        />
      </Box>
    </Box>
  );
};
